import { createWebHistory, createRouter } from "vue-router";
import store from "@/store"
const routes = [{
        path: '/',
        component: () =>
            import ('@/layout'),
        redirect: 'home',
        children: [{
                path: '/home',
                name: 'home',
                component: () =>
                    import ('@/views/user/index'),
            },
            {
                path: 'user-detail',
                name: 'userDetail',
                component: () =>
                    import ('@/views/user/detail'),
            },
        ]
    },
    {
        path: '/reset-password',
        name: 'resetPassword',
        component: () =>
            import ('@/views/login/resetPassword')
    },
    {
        path: '/page',
        name: 'otherPage',
        component: () =>
            import ('@/views/register/otherPage')
    },
    {
        path: '/timeline',
        component: () =>
            import ('@/layout'),
        redirect: 'timeline',
        children: [{
                path: '',
                name: 'timeline',
                component: () =>
                    import ('@/views/timeline/index'),
            },
            {
                path: 'detail',
                name: 'timelineDetail',
                component: () =>
                    import ('@/views/timeline/detail'),
            },
            {
                path: 'create',
                name: 'timelineCreate',
                component: () =>
                    import ('@/views/timeline/create'),
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('@/views/login/index')
    },
    {
        path: '/logout',
        name: 'logout',
        component: () =>
            import('@/views/logout/index')
    },
    {
        path: '/register',
        name: 'register',
        component: () =>
            import ('@/views/register/index')
    },
    {
        path: '/like',
        redirect: 'like',
        component: () =>
            import ('@/layout'),
        children: [{
            path: '',
            name: 'like',
            component: () =>
                import ('@/views/like/index'),
        }, ]
    },
    {
        path: '/message',
        redirect: 'message',
        component: () =>
            import ('@/layout'),
        children: [{
                path: '',
                name: 'message',
                component: () =>
                    import ('@/views/message/index'),
            },
            {
                path: 'chat',
                name: 'chat',
                component: () =>
                    import ('@/views/message/chat'),
            },
        ]
    },
    {
        path: '/profile',
        redirect: 'profile',
        component: () =>
            import ('@/layout'),
        children: [{
                path: '',
                name: 'profile',
                component: () =>
                    import ('@/views/profile/index'),
            },
            {
                path: 'buy-point',
                name: 'buyPoint',
                component: () =>
                    import ('@/views/profile/buyPoint'),
            },
            {
                path: 'show-info-profile',
                name: 'showInfoProfile',
                component: () =>
                    import ('@/views/profile/showInfoProfile'),
            },
            {
                path: 'buy-point',
                name: 'buyPoint',
                component: () =>
                    import ('@/views/profile/buyPoint'),
            },
            {
                path: 'subscription',
                name: 'subscription',
                component: () =>
                    import ('@/views/profile/subscription'),
            },
            {
                path: 'very-age',
                name: 'veryAge',
                component: () =>
                    import ('@/views/profile/veryAge'),
            },
            {
                path: 'edit-profile',
                name: 'editProfile',
                component: () =>
                    import ('@/views/profile/editProfile'),
            },
            {
                path: 'campaign',
                redirect: 'campaign',
                component: () =>
                    import ('@/layout'),
                children: [{
                        path: '',
                        name: 'campaign',
                        component: () =>
                            import ('@/views/profile/campaign'),
                    },
                    {
                        path: 'detail',
                        name: 'campaignDetail',
                        component: () =>
                            import ('@/views/profile/campaignDetail'),
                    }
                ]
            },
            {
                path: 'favorite',
                name: 'favorite',
                component: () =>
                    import ('@/views/profile/favorite'),
            },
            {
                path: 'memo',
                name: 'memo',
                component: () =>
                    import ('@/views/profile/memo'),
            },
            {
                path: 'notification',
                redirect: 'notification',
                component: () =>
                    import ('@/layout'),
                children: [{
                        path: '',
                        name: 'notification',
                        component: () =>
                            import ('@/views/profile/notification'),
                    },
                    {
                        path: 'detail',
                        name: 'noticeDetail',
                        component: () =>
                            import ('@/views/profile/noticeDetail'),
                    }
                ]
            },
            {
                path: 'footprint',
                name: 'footprint',
                component: () =>
                    import ('@/views/profile/footprint'),
            },
            {
                path: 'settings',
                name: 'settings',
                component: () =>
                    import ('@/views/profile/settings'),
            },
        ]
    },
]

const router = createRouter({
    history: createWebHistory('/greed-greed-stg'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // always scroll to top
        return { top: 0 }
    },
});
router.beforeEach(() => {
    store.dispatch("route/showLoading")
    store.dispatch("layout/setHeader", false)
})

router.afterEach(() => {
    store.dispatch("route/hideLoading")
    store.dispatch("layout/setHeader", true)
})
export default router